module.exports = __webpack_public_path__ + "img/error-400.45f8df46.svg";